import * as React from "react"

type Props = {
  onClose: () => void
}

type State = {
  extraClass: string
}

declare var FB;

export default class extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props)
    this.state = {
      extraClass: ''
    }
  }

  componentDidMount() {
    if (typeof(FB) == 'undefined') {
      return;
    }

    FB.XFBML.parse();
    FB.Event.subscribe('xfbml.render', () => {
      this.setState({extraClass: "show"})
    })
  }

  render() {
    if (typeof(FB) == 'undefined') {
      return <></>;
    }

    return (
      <div className={`scrollin ${this.state.extraClass}`}>
        <div className={`fb-page  ${this.state.extraClass}`} data-adapt-container-width='true' data-hide-cover='false' data-href='https://www.facebook.com/gites' data-show-facepile='true' data-small-header='true'>
          <blockquote cite='https://www.facebook.com/gites' className='fb-xfbml-parse-ignore'>
            <a href="https://www.facebook.com/gites">Gites</a>
          </blockquote>
        </div>
        <div className='scrollin__close' onClick={() => this.props.onClose()}></div>
      </div>
    )
  }
}
